import React, { useEffect, useState } from "react";
import Layout from "../../components/layouts/Layout";
import Chart from "react-apexcharts";
import { client2 } from "../../operationalRequest";
import { Col, Divider, Row, DatePicker, DatePickerProps, Spin } from "antd";
import SelectTable from "../../components/formComponents/SelectTable";
import dayjs, { Dayjs } from "dayjs";
import CustomSelectOptions from "../../components/formComponents/CustomSelectOptions";
import { set } from "lodash";
const RealModbus = () => {
    const [data, setData] = useState<any[]>([]);
    const [loading, setLoading] = useState(true);
    const [dateType, setDateType] = useState("Last 15 data");
    const [date, setDate] = useState("" as any);
    const [outputType, setOutputType] = useState("Energy_0x6000");
    const [options, setOptions] = useState({
        chart: {
            borderRadius: 100,
            responsive: true,
        },
        noData: {
            text: "No data available",
            align: "center",
            offsetX: 0,
            offsetY: 0,
            style: {
                fontSize: "14px",
            },
        },
        legend: {
            position: "top",
        },
        xaxis: {
            type: "category",
            title: {
                text: "Minutes",
            },
            categories: [], // Dynamically update this
        },
        yaxis: {
            title: {
                text: "Energy Meter(kW)",
            },
            labels: {
                formatter: (value: any) => value.toFixed(2), // Format y-axis values
            },
        },
        dataLabels: {
            enabled: false,
        },
        stroke: {
            curve: "smooth",
            width: [2, 2, 2, 2],
        },
    });

    const outputOptions = [

        {
            "label": "Total active energy",
            "value": "Energy_0x6000"
        },
        {
            "label": "T1 Total active energy",
            "value": "Energy_0x6002"
        },
        {
            "label": "T2 Total active energy",
            "value": "Energy_0x6004"
        },
        {
            "label": "L1 Total active energy",
            "value": "Energy_0x6006"
        },
        {
            "label": "L2 Total active energy",
            "value": "Energy_0x6008"
        },
        {
            "label": "L3 Total active energy",
            "value": "Energy_0x600A"
        },
        {
            "label": "Forward active energy",
            "value": "Energy_0x600C"
        },
        {
            "label": "T1 Forward active energy",
            "value": "Energy_0x600E"
        },
        {
            "label": "T2 Forward active energy",
            "value": "Energy_0x6010"
        },
        {
            "label": "L1 Forward active energy",
            "value": "Energy_0x6012"
        },
        {
            "label": "L2 Forward active energy",
            "value": "Energy_0x6014"
        },
        {
            "label": "L3 Forward active energy",
            "value": "Energy_0x6016"
        },
        {
            "label": "Reverse active energy",
            "value": "Energy_0x6018"
        },
        {
            "label": "T1 Reverse active energy",
            "value": "Energy_0x601A"
        },
        {
            "label": "T2 Reverse Active Energy",
            "value": "Energy_0x601C"
        },
        {
            "label": "L1 Reverse active energy",
            "value": "Energy_0x601E"
        },
        {
            "label": "L2 Reverse active energy",
            "value": "Energy_0x6020"
        },
        {
            "label": "L3 Reverse active energy",
            "value": "Energy_0x6022"
        },
        {
            "label": "Total reactive energy",
            "value": "Energy_0x6024"
        },
        {
            "label": "T1 Total reactive energy",
            "value": "Energy_0x6026"
        },
        {
            "label": "T2 Total reactive energy",
            "value": "Energy_0x6028"
        },
        {
            "label": "L1 Total reactive energy",
            "value": "Energy_0x602A"
        },
        {
            "label": "L2 Total reactive energy",
            "value": "Energy_0x602C"
        },
        {
            "label": "L3 Total reactive energy",
            "value": "Energy_0x602E"
        },
        {
            "label": "Forward reactive energy",
            "value": "Energy_0x6030"
        },
        {
            "label": "T1 Forward reactive energy",
            "value": "Energy_0x6032"
        },
        {
            "label": "T2 Forward reactive energy",
            "value": "Energy_0x6034"
        },
        {
            "label": "L1 Forward reactive energy",
            "value": "Energy_0x6036"
        },
        {
            "label": "L2 Forward reactive energy",
            "value": "Energy_0x6038"
        },
        {
            "label": "L3 Forward reactive energy",
            "value": "Energy_0x603A"
        },
        {
            "label": "Reverse reactive energy",
            "value": "Energy_0x603C"
        },
        {
            "label": "T1 Reverse reactive energy",
            "value": "Energy_0x603E"
        },
        {
            "label": "T2 Reverse reactive energy",
            "value": "Energy_0x6040"
        },
        {
            "label": "L1 Reverse reactive energy",
            "value": "Energy_0x6042"
        },
        {
            "label": "L2 Reverse reactive energy",
            "value": "Energy_0x6044"
        },
        {
            "label": "L3 Reverse reactive energy",
            "value": "Energy_0x6046"
        },
        {
            "label": "Tariff",
            "value": "Energy_0x6048"
        },

        {
            "label": "Voltage",
            "value": "Measurements_0x5000"
        },
        {
            "label": "L1 Voltage",
            "value": "Measurements_0x5002"
        },
        {
            "label": "L2 Voltage",
            "value": "Measurements_0x5004"
        },
        {
            "label": "L3 Voltage",
            "value": "Measurements_0x5006"
        },
        {
            "label": "Grid frequency",
            "value": "Measurements_0x5008"
        },
        {
            "label": "Current",
            "value": "Measurements_0x500A"
        },
        {
            "label": "L1 Current",
            "value": "Measurements_0x500C"
        },
        {
            "label": "L2 Current",
            "value": "Measurements_0x500E"
        },
        {
            "label": "L3 Current",
            "value": "Measurements_0x5010"
        },
        {
            "label": "Total active power",
            "value": "Measurements_0x5012"
        },
        {
            "label": "L1 Active power",
            "value": "Measurements_0x5014"
        },
        {
            "label": "L2 Active power",
            "value": "Measurements_0x5016"
        },
        {
            "label": "L3 Active power",
            "value": "Measurements_0x5018"
        },
        {
            "label": "Total reactive power",
            "value": "Measurements_0x501A"
        },
        {
            "label": "L1 Reactive power",
            "value": "Measurements_0x501C"
        },
        {
            "label": "L2 Reactive power",
            "value": "Measurements_0x501E"
        },
        {
            "label": "L3 Reactive power",
            "value": "Measurements_0x5020"
        },
        {
            "label": "Total apparent power",
            "value": "Measurements_0x5022"
        },
        {
            "label": "L1 Apparent power",
            "value": "Measurements_0x5024"
        },
        {
            "label": "L2 Apparent Power",
            "value": "Measurements_0x5026"
        },
        {
            "label": "L3 Apparent Power",
            "value": "Measurements_0x5028"
        },
        {
            "label": "Power factor",
            "value": "Measurements_0x502A"
        },
        {
            "label": "L1 Power factor",
            "value": "Measurements_0x502C"
        },
        {
            "label": "L2 Power factor",
            "value": "Measurements_0x502E"
        },
        {
            "label": "L3 Power factor",
            "value": "Measurements_0x5030"
        }


    ] as any

    const fetchData = async (dateType: string) => {
        setLoading(true);
        try {
            const response = await client2.get(
                "api/modbus-devices?dateType=" + dateType + "&date=" + date + "&outputType=" + outputType,
            );
            // console.log("Response data:", response.data.data);
            const formattedData = response.data.data.map((series: any) => ({
                ...series,
                data: series.data.map((point: any) => ({
                    x: point.x, // Keep x as a string
                    y: point.y, // Keep y as a number
                })),
            }));

            setData(formattedData);

            // Dynamically update x-axis categories
            const categories =
                formattedData.length > 0
                    ? formattedData[0].data.map((point: any) => point.x)
                    : [];

            setOptions((prevOptions) => ({
                ...prevOptions,
                xaxis: {
                    ...prevOptions.xaxis,
                    categories: categories,
                    title: {
                        text: "Time",
                    },
                },
            }));
        } catch (error) {
            console.error("Error fetching chart data:", error);
            setData([]); // Handle error case
        }
        setLoading(false);
    };
    const onChange: (
        date: Dayjs | null,
        dateString: string | string[],
    ) => void = (date, dateString) => {
        if (date) {
            setDate(dateString);
        } else {
            setDate(null);
        }
    };
    useEffect(() => {
        fetchData(dateType);
    }, [dateType, date, outputType]);
    return (
        <div className="h-96">
            <h1 className="font-bold text-center text-xl mb-7">
                Modbus Device
            </h1>
            <div className="flex justify-start space-x-3">
                <div>
                    {dateType === "Last 15 data" && (
                        <DatePicker
                            defaultValue={dayjs()}
                            onChange={onChange}
                        />
                    )}
                    {dateType === "day" && (
                        <DatePicker
                            defaultValue={dayjs()}
                            onChange={onChange}
                        />
                    )}
                    {dateType === "week" && (
                        <DatePicker onChange={onChange} picker="week" />
                    )}
                    {dateType === "month" && (
                        <DatePicker onChange={onChange} picker="month" />
                    )}
                    {dateType === "year" && (
                        <DatePicker onChange={onChange} picker="year" />
                    )}
                </div>

                <div className="space-x-3 flex justify-start mt-1">
                    {["Last 15 data", "day", "week", "month", "year"].map((type) => (
                        <div
                            key={type}
                            onClick={() => {
                                setDateType(type);
                                setDate("");
                            }}
                            className="cursor-pointer"
                        >
                            <span
                                className={`px-2 py-[2px] rounded-lg text-white text-xs 
                            ${dateType === type ? "bg-gray-500" : "bg-blue-600"} 
                            hover:bg-gray-400`}
                            >
                                {type.charAt(0).toUpperCase() + type.slice(1)}
                            </span>
                        </div>
                    ))}
                </div>
            </div>
            <div className="flex justify-start space-x-3 mt-3 mt-3">
                {dateType === 'Last 15 data' && (
                    <CustomSelectOptions
                        options={outputOptions}
                        onChange={(value: any) => {
                            setOutputType(value);
                        }}
                        placeholder="Select Output"
                        value={outputType}
                        disabled={false}
                    />
                )}
            </div>
            <div className="relative w-full h-full">
                {loading && (
                    <div className="absolute inset-0 bg-white bg-opacity-70 flex items-center justify-center z-10">
                        <Spin size="large" />
                    </div>
                )}
                <Chart
                    type={"line"}
                    options={options as any}
                    series={data}
                    width="100%"
                    height="100%"
                />
            </div>

        </div>
    );
};

export default RealModbus;
